<template>
    <div>
      <div class="card">
        <div class="card-body">
          <p class="m-2">
            <span>
              <font-awesome-icon :icon="['fa', data.icon]" class="icon" />
            </span>
          </p>
          <h5 class="card-subtitle mb-2 m-2 mt-3" style="font-size: 17px" v-html="data.title"></h5>
          <h5 v-if="data.fullName" class="fw-bold m-2"  style="font-size: 17px">{{data.fullName}}</h5>
          <p v-if="data.description" class="m-2">
            {{ data.description }}
            <a :href="`tel:${data.tel}`" v-if="data.tel" class="card-link text-decoration-none">
              {{ data.tel }}
            </a>
          </p>
          <p v-if="data.position" class="m-2">
            {{ data.position }}
          </p>
          <p v-if="data.email" class="m-2">
            <a v-html="data.email" class="text-decoration-none"/>
          </p>
          <p v-if="data.tel1" class="m-2">
              <a v-html="data.tel1" class="text-decoration-none" />
          </p>
          <p v-if="data.address" class="m-2">
              {{data.address}}
          </p>
          <p v-if="data.button" class="m-2"  style="font-size: 17px">
            <a :href="data.button" class="card-link text-decoration-none">
              {{ data.buttonLabel }} &nbsp; 
              <font-awesome-icon icon="fa-solid fa-arrow-right"/>
            </a> 
          </p>
          <p v-if="data.button1" class="m-2" style="font-size: 17px">
            <a v-html="data.button1" class="text-decoration-none"/>
          </p>
          <p v-if="data.button2" class="m-2"  style="font-size: 17px">
            <a v-html="data.button2" class="text-decoration-none"/>
          </p>
        </div>
      </div>
    </div>
  </template>
<script>
export default {
    props:['data','button1']
}
</script>
<style scoped>
    a{
      text-decoration:none !important;
    }
    .card{
        border:none !important;
        border-radius:12px !important;
        box-shadow: var(--bs-box-shadow) !important;
        height: 100%; 
        display: flex;
        flex-direction: column;
    }
    p:first-child{
       width:45px;
       height:45px;
       background-color:#F5BD2A;
    }
    p:first-child span{
        width:24px;
        height:24px;
    }

    p:first-child{
        position:relative;
        border-radius:10px;
    }
    .icon{
        font-size:24px;
        width:24px;
        height:24px;
        color:#101828 !important;
        position:absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%); 
    }
    
    .card-subtitle{
        font-weight:600;
        line-height:26px;
        letter-spacing: 0%;
        color:#101828;
    }
    
    .card-text{
        font-size:15px;
        font-weight:400;
        line-height:23px;
        letter-spacing: 0%;
        color:#475467;
    }

    .card-body a{
        font-weight:600;
        font-size:18px;
        line-height:21px;
        letter-spacing: 0%;
        color:#2C3F5E;
        text-decoration:none;
    }

    @media(max-width:991px){
      .card-subtitle{
        margin-top:10px !important;
      }
    }

  
</style>